import React, { Component } from "react";
import "./CarViewDetail.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CarModel from "../CarModel/CarModel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

let value = "";
class CarViewDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = event => {
    value = event.target.value;
  };

  render() {
    return (
      <Grid
        container
        spacing={3}
        style={{ textAlign: "center", marginTop: "5px" }}
      >
        <Grid item xs={6} sm={6}>
          <img src={this.props.image} className="CarImage" />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Grid
            item
            xs={12}
            sm={12}
            style={{
              textAlign: "left",
              marginTop: "50px",
              marginLeft: "-40px"
            }}
          >
            <div className="CarModelName">{this.props.modelName}</div>
            <div className="CarVersion">{this.props.version}</div>
          </Grid>

          <Grid
            container
            spacing={3}
            xs={12}
            sm={12}
            offset={1}
            className="CarDetailGrid"
          >
            <Grid
              container
              spacing={0}
              xs={8}
              sm={8}
              offset={1}
              className="CarDetailGridIn"
            >
              <Grid item xs={12} sm={12}>
                <Grid container xs={12} sm={12} className="CarDetailGridCell">
                  <Grid item spacing={0} xs={8} sm={8} className="Radio">
                    <FormControlLabel
                      value="nosotros"
                      control={<Radio />}
                      label="Patentas con Nosotros"
                      className="RadioLabel"
                    />
                    <div className="RadioDetail">
                      Nos brindas tu documentacion. <br />
                      Te tomamos la firmas necesarias. <br /> Retiras la unidad.
                    </div>
                  </Grid>
                  <Grid
                    item
                    spacing={0}
                    xs={4}
                    sm={4}
                    offset={1}
                    className="RadioPrecio"
                  >
                    $40.200
                    <div className="PriceDetail">
                      A este importe se le suma el importe de patente y sellado
                      que liquida el registro.
                    </div>
                  </Grid>
                </Grid>
                <Grid container xs={12} sm={12} className="CarDetailGridCell">
                  <Grid item spacing={0} xs={8} sm={8} className="Radio">
                    <FormControlLabel
                      value="tucuenta"
                      control={<Radio />}
                      label="Patentas por tu cuenta"
                      className="RadioLabel"
                    />
                    <div className="RadioDetail">
                      Te entregamos todos los formularios necesarios. <br />
                      Presentas la documentacion en el registro.
                      <br />
                      Con las chapas en mano programamos la entrega. <br />
                      Retiras la unidad.
                    </div>
                  </Grid>
                  <Grid
                    item
                    spacing={0}
                    xs={4}
                    sm={4}
                    offset={1}
                    className="RadioPrecio"
                  >
                    $40.200
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={3} sm={3} className="CarDetailGridCellPrice">
              <div className="Precio">
                Precio Final <br />
                <div style={{ fontSize: "0.75rem", color: "#EC1C24" }}>
                  Con Patentamiento
                </div>{" "}
                <br />
                <div style={{ fontSize: "1.2rem", color: "#EC1C24" }}>
                  <b>{this.props.price}</b>
                </div>{" "}
                <br />
                <Link to="/carform">
                  <img src="/img/reservar.png" className="ReservarImgDetail" />
                </Link>
                <br />
                <div
                  style={{
                    fontSize: "0.8rem",
                    color: "rgba(179, 179, 179, 1)"
                  }}
                >
                  minimo de reserva <br />
                  <b>$5.000</b> <br /> <br />
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default CarViewDetail;
